import FaqCard from '../../pages/GuestHomepage/FaqBlock/FaqCard/FaqCard';
import styles from './DropDownBlock.module.scss';

const DropDownBlock = ({ dropdown_item }) => (
  <>
    <div className={styles.dropdown_container}>
      {dropdown_item.map(el => {
        return <FaqCard key={el?.id} title={el?.title} description={el?.description} />;
      })}
    </div>
  </>
);

export default DropDownBlock;
